import { request } from '@umijs/max';

export interface LoginParams {
  username: string;
  password: string;
}

export interface LoginResponse {
  success: boolean;
  message?: string;
  data?: {
    token: string;
    user: {
      id: number;
      username: string;
      full_name: string;
      role: 'admin' | 'counter' | 'viewer';
    };
  };
}

export interface CurrentUser {
  id: number;
  username: string;
  full_name: string;
  role: 'admin' | 'counter' | 'viewer';
}

// Login - Clear any existing token first to ensure clean login
export async function login(params: LoginParams): Promise<LoginResponse> {
  // Clear any existing auth data before login attempt
  clearAuth();
  
  return request<LoginResponse>('/auth/login', {
    method: 'POST',
    data: params,
    // Skip sending any authorization header for login
    skipErrorHandler: true,
  });
}

// Get current user info
export async function me(): Promise<{ success: boolean; data?: CurrentUser }> {
  return request('/auth/me', {
    method: 'GET',
  });
}

// Logout
export async function logout(): Promise<{ success: boolean }> {
  return request('/auth/logout', {
    method: 'POST',
  });
}

// Auth helpers
export function getToken(): string | null {
  const token = localStorage.getItem('access_token');
  console.log('[getToken] Reading token:', token?.substring(0, 30));
  return token;
}

export function setToken(token: string): void {
  console.log('[setToken] Received token:', token);
  console.log('[setToken] Token type:', typeof token);
  localStorage.setItem('access_token', token);
  console.log('[setToken] After save, reading back:', localStorage.getItem('access_token'));
}

export function removeToken(): void {
  localStorage.removeItem('access_token');
}

export function getCurrentUser(): CurrentUser | null {
  const userStr = localStorage.getItem('current_user');
  if (userStr) {
    try {
      return JSON.parse(userStr);
    } catch {
      return null;
    }
  }
  return null;
}

export function setCurrentUser(user: CurrentUser): void {
  localStorage.setItem('current_user', JSON.stringify(user));
}

export function removeCurrentUser(): void {
  localStorage.removeItem('current_user');
}

export function clearAuth(): void {
  removeToken();
  removeCurrentUser();
}
